// src/hooks/jobOrders/useGetJobOrder.js
import { useQuery } from "@tanstack/react-query";
import { getJobOrder } from "../../api/apiJobOrders";

const useGetJobOrder = (jobOrderId, options = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["job-order", jobOrderId],
        queryFn: () => getJobOrder(jobOrderId),
        enabled: !!jobOrderId && (options.enabled !== false),
    });

    return {
        jobOrder: data?.data || null,
        error,
        isLoading,
        refetch
    };
};

export default useGetJobOrder;
